import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './print.css'
import {Modal,Button} from 'antd'
const ifPlan ={
    N:'否',
    Y:'是'
}

const serviceArea = {
    1:'门到站',
    2:'站到门',
    3:'门到门',
    4:'站到站'
}
const clearType = {
    1:'山口快铁代办',
    2:'收货人自办',
}
const declareType = {
    1:'山口快铁代办',
    2:'订舱方自办',
}
const deliveryMethod = {
    1:'山口快铁代办',
    2:'订舱方自办',
}
const boxType = {
    1:'山口快铁备箱',
    2:'订舱方自备箱',
}
class KtSpaceModal extends PureComponent {
    hideModal = () =>{
        const {hideModal} = this.props
        hideModal()
    }

    render() {
        const {previewVisiable,previewData} = this.props
        const {deliveryPlaceVo} = previewData
        return (
            <Modal
                visible={previewVisiable}
                onCancel={this.hideModal}
                className='trackModel-style'
                footer={[<Button onClick={this.hideModal}>关闭</Button>]}
            >
                <div style={{width:'700px',height:'auto',margin: '0 auto' }}>
                    <h2>阿拉山口国际快铁有限公司订舱单</h2>
                    <table className="tablestyle">
                        <tbody>
                        <tr>
                            <th width="12%">订舱单编号</th>
                            <td width="38%">{previewData.cabinNo}</td>
                            <th width="12%">计划班期</th>
                            <td width="38%">{previewData.planTime}</td>
                        </tr>
                        <tr>
                            <th>始发站</th>
                            <td>{previewData.originCountry}&nbsp;{previewData.originCity}</td>
                            <th>目的站</th>
                            <td>{previewData.destinationCountry}&nbsp;{previewData.destinationCity}</td>
                        </tr>
                        <tr>
                            <th>订舱方名称<br/>(中英文)</th>
                            <td>{previewData.cabinName}</td>
                            <th>服务范围</th>
                            <td>{serviceArea[previewData.serviceArea]}</td>
                        </tr>
                        <tr>
                            <th>订舱方地址<br/>(中英文)</th>
                            <td>{previewData.cabinAddr}</td>
                            <th>箱型箱量</th>
                            <td>{previewData.containerNum} * {previewData.containerType}</td>
                        </tr>
                        <tr>
                            <th>订舱方联系人姓名及电话邮箱</th>
                            <td><p>{previewData.cabinContact}</p> <p>{previewData.cabinPhone}</p><p>{previewData.cabinMail}</p></td>
                            <th>在途信息接收邮箱</th>
                            <td>{previewData.wayMail}</td>
                        </tr>
                        <tr>
                            <th>发货人名称<br/>(中英文)</th>
                            <td>{previewData.shipperName}</td>
                            <th>收货人名称<br/>(中英文)</th>
                            <td>{previewData.consigneeName}</td>
                        </tr>
                        <tr>
                            <th>发货人地址<br/>(中英文)</th>
                            <td>{previewData.shipperAddr}</td>
                            <th>收货人地址 <br/>(中英文)</th>
                            <td>{previewData.consigneeAddr}</td>
                        </tr>
                        <tr>
                            <th>发货人联系人名称电话邮箱</th>
                            <td><p>{previewData.shipperContact}</p> <p>{previewData.shipperPhone}</p><p>{previewData.shipperMail}</p></td>
                            <th>收货人联系人名称电话邮箱</th>
                            <td><p>{previewData.consigneeContact}</p> <p>{previewData.consigneePhone}</p><p>{previewData.consigneeMail}</p></td>
                        </tr>
                        <tr>
                            <th>单证负责人联系方式</th>
                            <td><p>{previewData.chargeContact}</p></td>
                            <th>到货通知人Notify</th>
                            <td>
                                <p>{previewData.arriveContact}</p>
                                {/*<p> JACK</p>
                                <p> 1599528552</p>
                                <p>jack@gmail.com</p>*/}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="4" align="center">
                                服务内容
                            </td>
                        </tr>
                        <tr>
                            <th>提货方式</th>
                            <td>{deliveryMethod[previewData.deliveryMethod]}</td>
                            <th>箱属</th>
                            <td>{boxType[previewData.boxType]}</td>
                        </tr>
                        <tr>
                            <th>提货地址</th>
                            <td>
                                {previewData.collectAddr}
                            </td>
                            <th>装箱时间</th>
                            <td>{previewData.boxDt}</td>
                        </tr>
                        <tr>
                            <th>报关方式</th>
                            <td>{declareType[previewData.declareType]}</td>
                            <th>清关方式</th>
                            <td>{clearType[previewData.clearType]}</td>
                        </tr>
                        <tr>
                            <th>送货方式</th>
                            <td></td>
                            <th>送货地址</th>
                            <td></td>
                        </tr>
                        </tbody>
                    </table>

                    <table className="tablestyle">
                        <tbody>
                            <tr>
                                <td align="center">货物信息</td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="tablestyle">
                        <tbody>
                        <tr>
                            <th colSpan='2'>唛码标记Marks</th>
                            <th>品名(中文)</th>
                            <th>品名(英文)</th>
                            <th>国内HSCode</th>
                            <th>国外HSCode</th>
                            <th>包装</th>
                            <th>件数</th>
                            <th>总毛重KGS</th>
                            <th>总体积CBM</th>
                            <th>是否需要装箱方案</th>
                        </tr>
                        {previewData.cabinPackageVoList ? previewData.cabinPackageVoList.map((c,i) => (
                            <tr key={c.id}>
                                <td>{i+1}</td>
                                <td>{c.boxNo}</td>
                                <td width="10%">{c.name}</td>
                                <td width="10%">{c.nameEn}</td>
                                <td>{c.hscode}</td>
                                <td>{c.oHscode}</td>
                                <td>{c.packageKind}</td>
                                <td>{c.pcsNumber}</td>
                                <td>{c.grossWeight}</td>
                                <td>{c.volume}</td>
                                <td>{ifPlan[c.ifPlan]}</td>
                            </tr>
                        )):null}
                        </tbody>
                    </table>
                    <table className="tablestyle">
                        <tbody>
                        <tr>
                            <td style={{
                               textAlign: 'left'
                            }}>特别关注
                                <p>1、请准确、完整、如实填写订舱单。如有漏项、错项、不完全项将会影响贵司及时成功订舱及顺利发运，因信息有误导致的相关事宜由订舱方自行承担。</p>
                                <p>2、如装箱时间有任何更改，请于装箱日期前2个工作日通知阿拉山口国际快铁有限公司（以下简称山口快铁）确认。</p>
                                <p>3、集装箱还箱地——订舱方要求还箱至指定还箱场站。</p>
                                <p>4、铁路运输安全要求：货箱重心必须居中，绝对不能偏载、偏重、超重。不可出现货箱一头重一头轻或者一侧重一侧轻的偏载现象。如发生以上偏载、偏重、超重现象，应将货物掏出来重新装箱，所产生的掏、装箱等相关费用以实际为准，由订舱方自行承担。</p>
                                <p>5、如需我司提供代理清关服务，请订舱方提前向山口快铁提供准确齐全的货物清关单证，以便提供清关预审，节省清关时间，我司不承担由于因订舱方原因所造成的延误清关或产生额外问题的责任。</p>
                                <p>6、发车前11日订舱方需将此订舱单发送至山口快铁邮箱booking@cr-sf.cn，发车前5日将原件邮寄至山口快铁。</p>
                                <p>7、如有任何疑问，请联系我司订舱部门，电话：0991-6990900。</p>
                                <p>8、本订舱单一式两份，双方各执一份，具有同等法律效力。</p>
                                <div style={{
                                    paddingTop: '30px', textAlign: 'left',
                                    paddingLeft:'70%'
                                }}>
                                    <div>委托订舱方签名及盖章:</div>
                                    <div style={{paddingTop:'30px'}}>日期：</div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div className="line"></div>
                </div>
            </Modal>
        )
    }
}
export default KtSpaceModal
